import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import pkg from "package";
import * as actions from "./actions";
import * as getters from "./getters";

// Import All Modules
import app from "./modules/app";
import menu from "./modules/menu";

import auth from "./modules/account";
import staff from "./modules/staff";
import candidates from "./modules/candidates";
import applications from "./modules/applications";
import trainees from "./modules/trainees";
import candidate from "./modules/candidate";
import organization from "./modules/organization";
import offers from "./modules/offers";
import sessions from "./modules/sessions";
import events from "./modules/events";
import finances from "./modules/finances";
import dashboard from "./modules/dashboard";
import orders from "./modules/orders";
import commercialDashboard from "./modules/commercialDashboard";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "dec",
      paths: ["auth", "orders"]
    })
  ],
  actions,
  getters,
  modules: {
    app,
    menu,
    auth,
    staff,
    candidates,
    applications,
    trainees,
    candidate,
    organization,
    offers,
    sessions,
    events,
    finances,
    dashboard,
    orders,
    commercialDashboard
  },
  state: {
    pkg
  }
});
